/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
var lightFavIcon = document.querySelector('link#light-favicon');
var darkFavIcon = document.querySelector('link#dark-favicon');

matcher = window.matchMedia('(prefers-color-scheme: dark)');
matcher.addListener(onUpdate);
onUpdate();

function onUpdate() {
  if (matcher.matches) {
    darkFavIcon.remove();
  } else {
    lightFavIcon.remove();
  }
}

document.querySelectorAll('span.QuantitySelector__Button').forEach((el, k) => {
  el.addEventListener('keydown', e => {
    if (['Enter'].includes(e.key)) {
      e.preventDefault();
      const control = e.target.getAttribute('data-action');
      const direction = control === 'decrease-quantity' ? -1 : 1;
      const qtyInput = direction === -1 ? e.target.nextElementSibling : e.target.previousElementSibling;
      const modifier = 1;
      const currentValue = isNaN(parseInt(qtyInput.value, 10)) ?
        parseInt(qtyInput.getAttribute("min"), 10) || 1 :
        parseInt(qtyInput.value, 10);

      const newValue = currentValue + direction * modifier;

      qtyInput.value = newValue;
    }
  });
});


document.querySelectorAll('input.QuantitySelector__CurrentQuantity').forEach((el, k) => {
  el.addEventListener("keydown", e => {
    if (['ArrowUp', 'ArrowDown'].includes(e.key)) {
      e.preventDefault();

      const currentValue = isNaN(parseInt(e.target.value, 10)) ?
        parseInt(e.target.getAttribute("min"), 10) || 1 :
        parseInt(e.target.value, 10);

      const direction = e.key === 'ArrowUp' ? 1 : -1;
      const modifier = 1;
      const newValue = currentValue + direction * modifier;

      e.target.value = newValue;
    }
  });
});


if (window.matchMedia('(min-width:640px)').matches) {
  let productListContainer = document.getElementById('ProductList--slider');
  if (productListContainer) {
    let step = productListContainer.clientWidth / productListContainer.querySelectorAll('.ProductItem').length;
    let next = document.getElementById('GoRightCS');
    next.onclick = function () {
      productSideScroll(productListContainer, 'right', 100, step * 3, step);
    };
    let back = document.getElementById('GoLeftCS');
    back.onclick = function () {
      productSideScroll(productListContainer, 'left', 100, step * 3, step);
    };
    function productSideScroll(element, direction, speed, distance, step) {
      scrollAmount = 0;
      var slideTimer = setInterval(function () {
        if (direction == 'left') {
          element.scrollLeft -= step;
        } else {
          element.scrollLeft += step;
        }
        scrollAmount += step;
        if (scrollAmount >= distance) {
          window.clearInterval(slideTimer);
        }
      }, speed);
    }
  }
}

let categoryListContainer = document.querySelector('.shopby_category .CollectionList');

if(categoryListContainer) {
  let step = categoryListContainer.clientWidth / categoryListContainer.querySelectorAll('.CollectionItem').length;
  let next = document.getElementById('GoRight');
  next.onclick = function () {
    catSideScroll(categoryListContainer, 'right', 50, step * 1.1, step);
  };
  let back = document.getElementById('GoLeft');
  back.onclick = function () {
    catSideScroll(categoryListContainer, 'left', 50, step * 1.1, step);
  };
  function catSideScroll(element, direction, speed, distance, step) {
    scrollAmount = 0;
    var slideTimer = setInterval(function () {
      if (direction == 'left') {
        element.scrollLeft -= step;
      } else {
        element.scrollLeft += step;
      }
      scrollAmount += step;
      if (scrollAmount >= distance) {
        window.clearInterval(slideTimer);
      }
    }, speed);
  }
}

function loadJQuery() {
  var waitForLoad = function () {
    if (typeof jQuery != "undefined") {
      console.info("jquery loaded..");
      var checkpoint = $('#shopify-section-announcement').outerHeight() + $('#shopify-section-header').outerHeight();

      var debounce = (method, delay) => {
        clearTimeout(method._tId);
        method._tId = setTimeout(function () {
          method();
        }, delay);
      }

      // bind custom jQuery methods
      jQuery.fn.isInViewport = function () {
        var elementTop = jQuery(this).offset().top;
        var elementBottom = elementTop + jQuery(this).outerHeight();
        var viewportTop = jQuery(window).scrollTop();
        var viewportBottom = viewportTop + jQuery(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
      };

      var initAnimation = () => {
        //landing page with logo overlay on hero
        const $overlayLogos = $('.SectionHeader__OverlayLogos');

        if ($overlayLogos.length) {
          const currentScroll = window.pageYOffset;
          const checkpointTop = checkpoint + $overlayLogos.find('img').first().outerHeight();
          const checkpointBottomStart = $(window).height() - $overlayLogos.find('img').last().outerHeight();
          const checkpointBottomEnd = $(window).height();
          var topOpacity = 1;
          var bottomOpacity = 1;
          if (currentScroll <= checkpointTop) {
            topOpacity = 1 - currentScroll / checkpoint;
          } else {
            topOpacity = 0;
          }

          if (currentScroll >= (checkpointBottomStart - checkpoint) && currentScroll <= checkpointBottomEnd) {
            bottomOpacity = 1 - currentScroll / checkpointBottomStart;
          } else if (currentScroll >= checkpointBottomStart) {
            bottomOpacity = 0;
          }

          $overlayLogos.find('img').first().css({
            'opacity': topOpacity
          });
          $overlayLogos.find('img:nth-child(2)').css({
            'opacity': topOpacity
          });
          $overlayLogos.find('img').last().css({
            'opacity': bottomOpacity
          });
          $overlayLogos.find('img:nth-child(3)').css({
            'opacity': bottomOpacity
          });
        }

        $('.SectionHeader__Heading').each((i, e) => {
          let $this = $(e);
          let $highlightCircle = $this.find('.Icon--highlight-circle');
          if ($this.isInViewport() && $highlightCircle.hasClass('hidden')) {
            if ($this.text().toLowerCase().indexOf('sleep') !== -1 || $this.text().toLowerCase().indexOf('slept') !== -1) {
              $this.find('.text-to-highlight').remove();
              let text = $this.html();
              let match = text.match(/sleepers|slept|sleep|Sleepers|Slept|Sleep/)[0];
              let newText = text.replace(/sleepers|slept|sleep|Sleepers|Slept|Sleep/, '<span class="text-to-highlight">' + match + '</span>');
              $this.html(newText); //Set wrapper
              let offset = $this.find(".text-to-highlight").offset();
              let width = $this.find(".text-to-highlight").width();
              let height = $this.find(".text-to-highlight").height();
              $this.html(text); //Place back
              let bottomPos = $this.offset().top + $this.height() - offset.top - height;
              let leftPos = offset.left - $this.offset().left;
              $this.find('.Icon--highlight-circle').removeClass('hidden').css({
                'bottom': bottomPos - 10,
                'left': leftPos - 20,
                'width': width * 1.5,
                'height': height * 1.5
              });
            }
          }
        });

        $('.Chart__Level, .Chart__Result').each((i, e) => {
          let $this = $(e);
          if ($this.isInViewport()) {
            $this.addClass('connect');
          } else {
            $this.removeClass('connect');
          }
        });
      }

      var initCarousel = () => {
        if ($('.Product__Featured-Reviews__Carousel').length) {
          $('.Product__Featured-Reviews__List').flickity({
            cellAlign: 'left',
            wrapAround: false,
            prevNextButtons: true,
            autoPlay: false,
            pageDots: true,
            lazyLoad: 1
          });
        }
      }

      var stickScrollingText = () => {
        // only execute on desktop homepage
        if (window.location.pathname == '/') {
          // header height can change
          checkpoint = $('#shopify-section-announcement').outerHeight() + $('#shopify-section-header').outerHeight();
          const $scrollingText = $('.scrolling-text');

          if ($scrollingText.length) {
            const currentScroll = window.pageYOffset;
            const checkpointTop = $('#section-slideshow').outerHeight() - $('#shopify-section-announcement').outerHeight() - $('#shopify-section-header').outerHeight();
            if (currentScroll <= checkpointTop) {
              $scrollingText.removeClass('sticky_active');
            } else {
              $scrollingText.addClass('sticky_active');
              $scrollingText.css({
                'top': (checkpoint - 1) + 'px'
              });
            }
          }

        }

      }

      $('a.attn_trigger').on('click', (e) => {
        e.preventDefault();

        if(window.innerWidth >= 1024){
          window.__attentive.trigger(null, null, null, 337197);
        } else {
          window.__attentive.trigger(null, null, null, 333904);
        }
      });

      $('[data-drawer-id="sidebar-menu"]').on('click', () => {
        // open the first menu on mobile
        $('.SidebarMenu__Nav > .Collapsible').each((i, el) => {
          const $this = $(el);
          const $first_collapsible = $this.find('.Collapsible__Inner .Collapsible:eq(0) .Collapsible__Button');
          $first_collapsible.click();
        });
      });

      initAnimation();
      initCarousel();

      jQuery(window).on('resize scroll orientationchange', function (evt) {
        if (evt.type == 'resize' || evt.type == 'orientationchange') {
          $('.Icon--highlight-circle').addClass('hidden');
        }
        initAnimation();
        initCarousel();
      });

      if (typeof hasTimer !== 'undefined' && hasTimer) {
        var offerEndDay = $('span[data-end-date]').attr('data-end-date');
        $('.timer').countdown(offerEndDay, function (event) {
          $(this).addClass('active');
          $(this).html(
            event.strftime('<b>%H</b><i>hrs</i><b>%M</b><i>min</i><b>%S</b><i>sec</i>')
          );
        });
      }

      $('.Button-Phone').on('click', function (e) {
        e.preventDefault();
        $(this).hide();
        $(this).next().fadeIn();
      });

      $('a.feature-expand, a.feature-collapse').on('click', (e) => {
        e.preventDefault();
        const $target = $(e.target);
        if ($target.hasClass('feature-expand')) {
          $target.hide();
        }
        if ($target.hasClass('feature-collapse')) {
          $target.hide();
        }
        $target.parent().find('.Extended').slideToggle(() => {
          if ($target.hasClass('feature-expand')) {
            $target.parent().find('.feature-collapse').show();
          }

          if ($target.hasClass('feature-collapse')) {
            $target.parent().find('.feature-expand').show();
          }
        });
      });

      $('#section-collection-hero-fullscreen a').on('click', (e) => {
        var $target = $(e.target);
        if ($target.attr('href').indexOf('#') === 0) {
          $('html,body').animate({
            scrollTop: $($target.attr('href')).offset().top - checkpoint
          });
        }
      });

      $('#shopify-section-slideshow .Slideshow__Content, .Footer__Block--newsletter').each((i, e) => {
        $heading = $(e).find('.SectionHeader__Heading, .Footer__Title');
        $heading.html($heading.html().replace(/([.])/g, '<span class="colordot">.</span>'));
      });

      $('.Product__Tabs-NavItem').on('click', (e) => {
        e.preventDefault();
        var $target = $(e.target);
        var tabContentId = $target.attr('data-toggle');

        $('.Product__Tabs-Panel, .Product__Tabs-NavItem').removeClass('is-active');
        $('.Product__Tabs-Panel, .Product__Tabs-NavItem').each((i, tb) => {
          $(tb).attr('aria-selected', false);
        });
        $target.attr('aria-selected', true);
        $target.addClass('is-active');
        $('#' + tabContentId).addClass('is-active');
      });

      $('.filter-block a').on('click', (e) => {
        e.preventDefault();
        if ($(e.target).parents('#shopify-section-collection-header').length) return;
        
        var $slider = $('.Slider.CollectionList');
        if ($slider.length) {
          var targetTag = $(e.target).attr('href').replace('#', '');
          $('.filter-block').removeClass('filter-active');
          $(e.target).parent().addClass('filter-active');
          targetTag = 'home_featured_' + targetTag.replace('-', ' ');
          $('.CollectionItem.ProductItem').each((k, p) => {
            var productTags = $(p).attr('data-tags').toLowerCase();
            if (productTags.indexOf(targetTag) > -1) {
              $(p).removeClass('filtered');
            } else {
              $(p).addClass('filtered');
            }
          });

          if ($('.CollectionItem.ProductItem:not(.filtered)').length > 3) {
            $slider.addClass('spacing-between');
            $slider.removeClass('center');
          } else if ($('.CollectionItem.ProductItem:not(.filtered)').length == 2) {
            $slider.removeClass('spacing-between').addClass('center');
          } else {
            $slider.removeClass('spacing-between');
            $slider.removeClass('center');
          }
        } else {
          var targetCollection = $(e.target).attr('href').replace('#', '');
          $('.filter-block').removeClass('filter-active');
          $(e.target).parent().addClass('filter-active');
          $('.ProductList').removeClass('filter-active');
          $('.ProductList.' + targetCollection).addClass('filter-active');
        }

        return false;
      });

      if (!window.matchMedia('screen and (max-width: 640px)').matches) {
        $('.Footer__Block--links').each((i, e) => {
          var $this = $(e);

          $this.find('.Collapsible').removeClass('Collapsible');
          $this.find('.Collapsible__Button').removeAttr('data-action')
          $this.find('.Collapsible__Button').attr('aria-expanded', 'true');
          $this.find('.Collapsible__Plus').remove();
          $this.find('.Collapsible__Inner').css({
            'overflow': 'visible',
            'height': 'auto'
          });
        });
      }

      var $iconCarousel = $('.Press-Section .list-icon-carousel').flickity({
        setGallerySize: false,
        cellAlign: 'center',
        wrapAround: true,
        prevNextButtons: false,
        autoPlay: false,
        pageDots: false,
        on: {
          change: function (index) {
            $textCarousel.flickity('select', index);
          }
        }
      });

      var iconFlkty = $iconCarousel.data('flickity');
      $iconCarousel.on('select.flickity', function (event, index) {
        $textCarousel.flickity('select', iconFlkty.selectedIndex);
      });

      var $textCarousel = $('.Press-Section .list-text-carousel').flickity({
        cellAlign: 'center',
        wrapAround: true,
        prevNextButtons: true,
        autoPlay: false,
        pageDots: false,
        lazyLoad: 1
      });

      var textFlkty = $textCarousel.data('flickity');
      $textCarousel.on('select.flickity', function (event, index) {
        $iconCarousel.flickity('select', textFlkty.selectedIndex);
      });

      var className = window.matchMedia('(max-width:640px)').matches ? 'footer-mobile-background' : 'footer-background';

      if (window.location.pathname.indexOf('/products') === -1) {
        var $footer = $('main > #shopify-section-footer');
        $('main').find(">:last-child").after('<div class="' + className + '">' + $footer[0].outerHTML + '</div>');
        $footer.remove();
      }

      $('.Product__Related-Products__Carousel .ProductList--carousel').flickity({
        "prevNextButtons": false,
        "cellAlign": "left",
        "wrapAround": true
      });

      $('.Select-Options').on('click', (e) => {
        e.preventDefault();
        var $header = $('#global-header');

        $('html, body').animate({
          'scrollTop': $('.Product .ProductForm:eq(0)').offset().top - $header.outerHeight()
        });
      });

      if (window.matchMedia('screen and (max-width: 640px)').matches) {
        $('.Product__Press-List').flickity({
          'prevNextButtons': false,
          'wrapAround': true,
          'dragThreshold': 8,
          'groupCells': false,
          'pageDots': false,
          'autoPlay': true
        });

        $('.Product__Tabs-Content .Collapsible__Button').on('click', (e) => {
          var $this = $(e.target);
          var $header = $('#global-header');
          setTimeout(function () {
            if ($this.attr('aria-expanded') === 'true') {
              $('html, body').animate({
                'scrollTop': $this.offset().top - $header.outerHeight()
              });
            }
          }, 5);
        });
      }

      $('.PostList').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        variableWidth: false,
        dots: true,
        adaptiveHeight: false,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev"><span class="u-visually-hidden">Previous slide</span><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><span class="u-visually-hidden">Next slide</span><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
        draggable:false,
        infinite: true,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }
        ]
      });

      if (window.location.pathname.indexOf('/products/') !== -1 || window.location.pathname.indexOf('/collections/') !== -1) {
        $('.ReviewList').slick({
          slidesToShow: 3,
          variableWidth: false,
          centerMode: true,
          centerPadding: '0',
          dots: true,
          focusOnSelect: true,
          arrows: true,
          prevArrow: '<button type="button" class="slick-prev"><span class="u-visually-hidden">Previous slide</span><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
          nextArrow: '<button type="button" class="slick-next"><span class="u-visually-hidden">Next slide</span><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
          draggable: false,
          autoplay: true,
          infinite: true,
          autoplaySpeed: 5000,
          cssEase: 'linear',
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      }

      function mobileFirstSlides() {
        if (!$('.ProductCompareList').hasClass("slick-initialized")) {
          $('.ProductCompareList').slick({
            mobileFirst: true,
            slidesToShow: 1,
            variableWidth: false,
            centerMode: true,
            centerPadding: '0',
            dots: true,
            arrows: false,
            draggable: true,
            infinite: true,
            cssEase: 'linear',
            responsive: [
              {
                breakpoint: 480,
                settings: "unslick"
              }
            ]
          });
        }

        if (!$('.product-upsell-list .ProductList').hasClass("slick-initialized")) {
          $('.product-upsell-list .ProductList').slick({
            mobileFirst: true,
            slidesToShow: 1,
            variableWidth: false,
            centerMode: true,
            centerPadding: '0',
            dots: true,
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev"><span class="u-visually-hidden">Previous slide</span><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><span class="u-visually-hidden">Next slide</span><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
            draggable: false,
            infinite: true,
            cssEase: 'linear',
            responsive: [
              {
                breakpoint: 1024,
                settings: "unslick"
              }
            ]
          });
        }

        if (!$('.ImageHero__Content-List .LogoList').hasClass("slick-initialized")) {
          $('.ImageHero__Content-List .LogoList').slick({
            mobileFirst: true,
            slidesToShow: 2,
            variableWidth: false,
            centerMode: false,
            centerPadding: '0',
            dots: false,
            arrows: false,
            draggable:false,
            autoplay:true,
            infinite: true,
            autoplaySpeed: 8000,
            cssEase: 'linear',
            responsive: [
              {
                breakpoint: 768,
                settings: "unslick"
              }
            ]
          });
        }

        if (!$('.template-best-seller .ProductSet__Container').hasClass("slick-initialized")) {
          $('.template-best-seller .ProductSet__Container').slick({
            mobileFirst: true,
            slidesToShow: 1,
            variableWidth: false,
            centerMode: false,
            centerPadding: '0',
            dots: true,
            arrows: false,
            draggable:false,
            autoplay:false,
            infinite: true,
            cssEase: 'linear',
            responsive: [
              {
                breakpoint: 1025,
                settings: "unslick"
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2
                }
              },
              {
                breakpoint: 540,
                settings: {
                  slidesToShow: 1
                }
              }
            ]
          });
        }

        if (!$('.template-best-seller .IconSet__Container').hasClass("slick-initialized")) {
          $('.template-best-seller .IconSet__Container').slick({
            mobileFirst: true,
            slidesToShow: 1,
            variableWidth: false,
            centerMode: false,
            centerPadding: '0',
            dots: true,
            arrows: false,
            draggable:false,
            autoplay:true,
            infinite: true,
            autoplaySpeed: 5000,
            cssEase: 'linear',
            responsive: [
              {
                breakpoint: 1025,
                settings: "unslick"
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2
                }
              },
              {
                breakpoint: 540,
                settings: {
                  slidesToShow: 1
                }
              }
            ]
          });
        }
      }

      mobileFirstSlides();

      $(window).on("resize orientationchange", function () {
        if (!$('.ProductCompareList').hasClass("slick-initialized")
          || !$('.product-upsell-list .ProductList').hasClass("slick-initialized")
          || !$('.ImageHero__Content-List .LogoList').hasClass("slick-initialized")
          || !$('.template-best-seller .ProductSet__Container').hasClass("slick-initialized")) {
          return mobileFirstSlides();
        }
      });
    } else {
      console.log("jquery not loaded..");
      window.setTimeout(waitForLoad, 500);
    }
  };
  window.setTimeout(waitForLoad, 500);
}

window.onload = loadJQuery;

(function () {
  let touchingCarousel = false,
    touchStartCoords;

  document.body.addEventListener('touchstart', function (e) {
    if (e.target.closest('.flickity-slider')) {
      touchingCarousel = true;
    } else {
      touchingCarousel = false;
      return;
    }

    touchStartCoords = {
      x: e.touches[0].pageX,
      y: e.touches[0].pageY
    }
  });

  document.body.addEventListener('touchmove', function (e) {
    if (!(touchingCarousel && e.cancelable)) {
      return;
    }

    let moveVector = {
      x: e.touches[0].pageX - touchStartCoords.x,
      y: e.touches[0].pageY - touchStartCoords.y
    };

    if (Math.abs(moveVector.x) > 7)
      e.preventDefault()

  }, {
    passive: false
  });
})();

(function () {
  if(window.location.pathname.indexOf('/products/') != -1) {
    const reward = document.querySelector('.product_media-item.reward');
    
    if(reward) {
      let siblings = Array.from(reward.parentElement.children).filter(
        el => el !== reward
      );
      
      let quote = siblings.find(el => el.classList.contains('quote-text'));
      
      if (quote) {
        quote.classList.add('wide-element');
      }
    }
  }
})();